import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import connect from "react-redux/es/connect/connect";
import classNames from 'classnames';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {
    getEstatisticaEtapa,
    getEstatisticasOSCalculoColaVerde,
    getOSContagemPorTipoPergunta
} from "../../actions/orderActions";
import OSRespostasBarChart from "../../components/OSRespostasBarChart";
import AplicacaoBandaKPIs from "./AplicacaoBandaKPIs";
import AplicacacoBandaColaVerdePieChart from "./AplicacaoBandaColaVerdePieChart";
import Typography from "@material-ui/core/Typography";
import OSESeriesDHChart from "../../components/OSESeriesDHChart";

//const stations = [1,2,3,4]

const styles = theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
      marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
      marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
      paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
});

class AplicacaoBanda extends Component {
    constructor(props) {
        super(props);


        // document.title = 'Conserto';

        this.renderContent = this.renderContent.bind(this);
        this.renderLoadingScreen = this.renderLoadingScreen.bind(this);
        this.onFilterClick = this.onFilterClick.bind(this);
    }

    componentDidMount(): void {
        this.props.getEstatisticaEtapa(18);
        this.props.getOSContagemPorTipoPergunta(181);
        //this.props.getOSContagemPorTipoPergunta(182);
        this.props.getEstatisticasOSCalculoColaVerde();
    }

    onFilterClick = () => {
        this.props.getEstatisticaEtapa(18);
        this.props.getOSContagemPorTipoPergunta(181);
        //this.props.getOSContagemPorTipoPergunta(182);
        this.props.getEstatisticasOSCalculoColaVerde();
    }

    componentDidUpdate(oldProps, oldState){
        //if (oldProps.filter.)

        // if (JSON.stringify(oldProps.filter) !== JSON.stringify(this.props.filter)) {
        //     this.props.getEstatisticaEtapa(18);
        //     this.props.getOSContagemPorTipoPergunta(181);
        //    // this.props.getOSContagemPorTipoPergunta(182);
        //     this.props.getEstatisticasOSCalculoColaVerde();
        // }
    }


    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }

    renderContent(){
        const { classes } = this.props;

        console.log("aplicacao banda", this.props);
        const p181 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 181);

        return (<Grid container direction="column">
            <Grid container item direction="row" alignItems="stretch" spacing={16}>


                <Grid item xs={12} className={classes.marginBottom}>
                    <AplicacaoBandaKPIs isLoading={this.props.isLoading}  dados={this.props.aplicacaoBanda}  filter={this.props.filter} />
                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <OSESeriesDHChart isLoading={this.props.isLoading} series={this.props.aplicacaoBanda.distribuicaoDataHora}
                                      filter={this.props.filter} title="RITMO POR HORA"/>
                </Grid>

                {/*<Grid item xs={12} className={classes.marginBottom}>*/}
                {/*    <OSRespostasBarChart isLoading={this.props.isLoading}  series={this.props.osContagemPorTipoPergunta.contagem}   filter={this.props.filter} title="LOTE BANDA" serieTitle="QTDE" />*/}
                {/*</Grid>*/}

                <Grid item xs={12} className={classes.marginBottom}>
                    <OSRespostasBarChart isLoading={this.props.isLoading}  series={p181? p181.contagem : []}  filter={this.props.filter} title="CODIGO BANDA" />
                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <AplicacacoBandaColaVerdePieChart isLoading={this.props.isLoading}  series={this.props.colaVerde}   filter={this.props.filter} title="COLA VERDE" serieTitle="espera min" />
                </Grid>
            </Grid>
        </Grid>)

    }

    //TODO: reactgridlayout https://github.com/STRML/react-grid-layout
    render() {
        const { classes, isLoading } = this.props;

        return (
            <React.Fragment>
                <Grid container direction="column" className={classes.dashboardSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} onButtonClick={this.props.getRaspaCycleHourUsageStatistics}
                                        loading={this.props.loading} onFilterClick={this.onFilterClick} />/>
                    </Grid>
                </Grid>
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        APLICAÇÃO DA BANDA
                    </Typography>
                </Grid>
                { isLoading ? this.renderLoadingScreen() : this.renderContent() }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        aplicacaoBanda: state.ordemServicoReducer.aplicacaoBanda,
        loading : state.ordemServicoReducer.isFetchingEstatisticaEtapa,
        filter: state.filter,
        osContagemPorTipoPergunta: state.ordemServicoReducer.osContagemPorTipoPergunta,
        colaVerde: state.ordemServicoReducer.colaVerde,
        fullreducer: state,
    }
}


export default connect(mapStateToProps, {getEstatisticaEtapa, getOSContagemPorTipoPergunta, getEstatisticasOSCalculoColaVerde} ) (withStyles(styles, {withTheme: true})(AplicacaoBanda));
